import { render, staticRenderFns } from "./HeaderTransactions.vue?vue&type=template&id=3fa87b22"
import script from "./HeaderTransactions.vue?vue&type=script&lang=js"
export * from "./HeaderTransactions.vue?vue&type=script&lang=js"
import style0 from "./HeaderTransactions.vue?vue&type=style&index=0&id=3fa87b22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports